import React from "react";
// import { Clock, Coffee, HelpCircle, Share2 } from "lucide-react";
import { SubHeaderProps } from "./types";
import { HelpCircle } from "lucide-react";
import ExitButton from "../../../src/components/ExitButton";
import exitIcon from "../../assets/images/exit.svg";
import usePartnerAwareNavigate from "../../hooks/usePartnerAwareNavigate";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../src/components/ui/Dialog";
import { Button } from "../../components/ui/Button";

const SubHeader: React.FC<SubHeaderProps> = ({
  timeSpent,
  date,
  caseName, // Adding default title
}) => {
  const navigate = usePartnerAwareNavigate();
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);

  const handleExit = () => {
    setIsDialogOpen(true);
  };

  const handleConfirmExit = () => {
    setIsDialogOpen(false);
    navigate("/");
  };

  return (
    <>
      <div className="flex justify-between items-center px-6 py-3 bg-[#F8F9FA] font-product-sans">
        <div className="flex items-center gap-8">
          {/* Title with specified styling */}
          <h1 className="text-[20px] text-[#1F2024] font-bold leading-[28px]">
            {caseName}
          </h1>
          {/* Time info as secondary element */}
          <div className="flex items-center gap-4 text-[#474A52]">
            <span className="text-[16px] font-normal">
              Time Spent: {timeSpent}
            </span>
            <span className="text-[16px] text-[#474A52] font-normal">
              {date}
            </span>
          </div>
        </div>
        <div className="flex gap-4">
          <ExitButton iconSrc={exitIcon} onExit={handleExit} />
          {/* <button
            className="flex items-center gap-2 px-3 py-1 rounded border bg-[#FFF] text-[0.95rem] text-[#333] font-normal 
            hover:text-[#1B58F4] hover:border-[#1B58F4] transition-colors duration-200"
          >
            <HelpCircle className="w-4 h-4" />
            FAQ
          </button> */}
          {/* <button
            className="flex items-center gap-2 px-3 py-1 rounded border  bg-[#FFF] text-[0.95rem] text-[#333] font-normal 
            hover:text-[#1B58F4] hover:border-[#1B58F4] transition-colors duration-200"
          >
            <Coffee className="w-4 h-4" />
            Buy us a coffee
          </button>
          <button
            className="flex items-center gap-2 px-3 py-1 rounded border bg-[#FFF]  text-[0.95rem] text-[#333] font-normal 
            hover:text-[#1B58F4] hover:border-[#1B58F4] transition-colors duration-200"
          >
            <Share2 className="w-4 h-4" />
            Feedback
          </button> */}
        </div>
      </div>

      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Are you sure you want to leave?</DialogTitle>
            <DialogDescription className="pt-2 space-y-2">
              <p>
                We have a detailed report with MBB interviewer-verified feedback
                to help you improve your performance.
              </p>
              <p>
                You can also access audio playback of your responses for better
                self-reflection.
              </p>
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="flex gap-2 sm:justify-end">
            <Button
              type="button"
              variant="outline"
              onClick={() => setIsDialogOpen(false)}
            >
              Stay on Report
            </Button>
            <Button
              type="button"
              variant="default"
              onClick={handleConfirmExit}
              className="bg-[var(--color-primary)] hover:bg-[var(--color-primary)]/90"
            >
              Leave Anyway
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SubHeader;
